/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../../queryTyping';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type SetTimeZoneMutationVariables = Types.Exact<{
  data: Types.UserTimeZoneInput;
}>;


export type SetTimeZoneMutation = (
  { __typename?: 'Mutation' }
  & { timeZone: (
    { __typename?: 'SetTimeZoneResult' }
    & Pick<Types.SetTimeZoneResult, 'successful'>
    & { userTimeZone: (
      { __typename?: 'UserTimeZone' }
      & Pick<Types.UserTimeZone, 'id' | 'name'>
    ), errors: Types.Maybe<Array<(
      { __typename?: 'ValidationItem' }
      & Pick<Types.ValidationItem, 'messages'>
    )>> }
  ) }
);


export const SetTimeZoneDocument = gql`
    mutation SetTimeZone($data: UserTimeZoneInput!) {
  timeZone(data: $data) {
    userTimeZone {
      id
      name
    }
    successful
    errors {
      messages
    }
  }
}
    `;
export type SetTimeZoneMutationFn = Apollo.MutationFunction<SetTimeZoneMutation, SetTimeZoneMutationVariables>;

/**
 * __useSetTimeZoneMutation__
 *
 * To run a mutation, you first call `useSetTimeZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTimeZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTimeZoneMutation, { data, loading, error }] = useSetTimeZoneMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetTimeZoneMutation(baseOptions?: Apollo.MutationHookOptions<SetTimeZoneMutation, SetTimeZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTimeZoneMutation, SetTimeZoneMutationVariables>(SetTimeZoneDocument, options);
      }
export type SetTimeZoneMutationHookResult = ReturnType<typeof useSetTimeZoneMutation>;
export type SetTimeZoneMutationResult = Apollo.MutationResult<SetTimeZoneMutation>;
export type SetTimeZoneMutationOptions = Apollo.BaseMutationOptions<SetTimeZoneMutation, SetTimeZoneMutationVariables>;